<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Manage Services</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form">
              <base-input label="Category">
                <multiselect
                  placeholder="Select Category"
                  v-model="cmbCat.value"
                  :options="cmbCat.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbCat"
                >
                </multiselect>
              </base-input>

              <base-input
                label="Name:"
                class="mb-3"
                name="batch"
                type="text"
                placeholder="Enter service name"
                v-model="myObj.name"
                v-bind:error="nameError"
              />

              <base-input
                label="Cost"
                class="mb-3"
                name="batch"
                type="decimal"
                placeholder="Enter cost"
                v-model="myObj.cost"
                v-bind:error="costError"
              />
              <base-input
                label="Time"
                class="mb-3"
                name="batch"
                type="number"
                placeholder="Enter service time"
                v-model="myObj.time"
                v-bind:error="timeError"
              />

              <base-input label="Featured service?">
                <multiselect
                  placeholder="Featured service?"
                  v-model="cmbFeatured.value"
                  :options="cmbFeatured.data"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :hide-selected="false"
                  :preserve-search="true"
                  label="name"
                  track-by="name"
                  :preselect-first="true"
                  id="cmbFeatured"
                >
                </multiselect>
              </base-input>

              <div>
                <base-button
                  @click="AddService()"
                  :disabled="saving"
                  type="primary"
                  class="col"
                  ><i v-bind:class="sign"></i> {{ optionName }}</base-button
                >
              </div>
            </form>
          </template>
        </card>
      </modal>

      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div style="margin-bottom: 5px">
                <base-button icon type="primary" @click="AddModal()">
                  <span class="btn-inner--icon"
                    ><i class="fas fa-plus"></i
                  ></span>
                  <span class="btn-inner--text">Add new service</span>
                </base-button>

                <base-button
                  hidden
                  icon
                  v-if="selectedRows.length"
                  type="danger"
                  @click="RemoveSelected()"
                >
                  <span class="btn-inner--icon"
                    ><i class="fas fa-trash"></i
                  ></span>
                  <span class="btn-inner--text">Remove selected</span>
                </base-button>
              </div>

              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>
              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>

                  <base-button
                    @click.native="handleDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import Multiselect from "vue-multiselect";
import { isValid } from "date-fns";

export default {
  mixins: [clientPaginationMixin],
  components: {
    Multiselect,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  created() {
    this.LoadData();
    this.FillCmbCat();
    //this.LoadCategoryDropdown();
  },
  mounted() {},
  data() {
    return {
      myObj: {
        serviceID: 0,
        categoryID: 0,
        name: "",
        cost: null,
        time: null,
        sequence: 1,
        contact: null,
        isFeatured: 0,
      },
      cmbCat: {
        value: {},
        data: [],
      },
      cmbFeatured: {
        value: {
          name: "No",
          value: 0,
        },
        data: [
          {
            name: "No",
            value: 0,
          },
          {
            name: "Yes",
            value: 1,
          },
        ],
      },
      file: "",
      propsToSearch: ["name"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 310,
          sortable: true,
        },
        {
          prop: "catName",
          label: "Category",
          minWidth: 200,
          sortable: true,
        },
        {
          prop: "cost",
          label: "Cost (AED)",
          minWidth: 150,
          sortable: true,
        },
        {
          prop: "time",
          label: "Time (min)",
          minWidth: 170,
          sortable: true,
        },
      ],
      tableData: [],
      categoryData: [],
      categoryOptions: [],
      selectedRows: [],
      modals: {
        showModal: false,
      },
      optionName: "Add",
      name: "",
      prefixname: "",
      prefixError: false,
      nameError: false,
      categoryError: false,
      costError: false,
      timeError: false,
      sequenceError: false,
      contactError: false,
      sign: "fas fa-user-plus",
      shouldAdd: true,
      saving: false,
      eIndex: 0,
      err: {
        nameerr: false,
        contacterr: false,
        mobileerr: false,
        purposevsterr: false,
        dateerr: false,
      },
    };
  },
  methods: {
    LoadData() {
      var url = this.$store.state.domain + "/services";
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
          } else {
            this.tableData = response.data;
          }
        })
        .catch(function (error) {});
    },
    FillCmbCat() {
      var url = this.$store.state.domain + "/categories";
      axios
        .get(url)
        .then((res) => {
          this.cmbCat.value = {};
          this.cmbCat.data = [];
          res.data.forEach((elem) => {
            this.cmbCat.data.push({
              name: elem.name,
              value: elem.categoryID,
            });
          });
        })
        .catch((err) => {
          console.error("cmbCat Fill", err);
        });
    },
    LoadCategoryDropdown() {
      var url = this.$store.state.domain + "/categories";
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
            //this.$notify({verticalalign: 'bottom', horizontalalign: 'center', message: 'Request Error! <br />' + response.data.status.data, type: 'danger', icon: 'fa fa-ban',timeout: 0 });
          } else {
            this.categoryOptions = response.data[categoryID];
          }
        })
        .catch(function (error) {});
    },
    AddService() {
      var regexName = /^[a-zA-Z ]{2,100}$/;
      var regexCost = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/;
      var regexTime = /^[a-zA-Z 0-9]{2,30}$/;
      var regexContact = /^[0-9]{2,15}$/;
      var isValidName = regexName.test(this.myObj.name);
      var isValidCost = regexCost.test(this.myObj.cost);
      var isValidTime = regexTime.test(this.myObj.time);
      var isValidContact = regexContact.test(this.myObj.contact);
      if (this.cmbCat.value === null || this.cmbCat.value.value === undefined) {
        swal({
          title: `Select category`,
          text: "Please select the category from dropdown.",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-error",
          type: "error",
        });
      } else if (this.myObj.name === "" || !isValidName) {
        this.nameError = "Please enter valid service name";
      } else {
        this.nameError = false;
        if (this.myObj.cost === null || this.myObj.cost <= 0 || !isValidCost) {
          this.costError = "Please enter valid cost amount";
        } else {
          this.costError = false;
          if (this.myObj.time === null || !isValid) {
            this.timeError = "Please enter valid service time in mins";
          } else {
            this.timeError = false;
            if (
              this.cmbFeatured.value === null ||
              this.cmbFeatured.value.value === undefined
            ) {
              swal({
                title: `Is service feartured?`,
                text: "Please select the last dropdown option.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-error",
                type: "error",
              });
            } else {
              if (this.myObj.serviceID === 0) {
                //Add
                this.myObj.categoryID = this.cmbCat.value.value;
                this.myObj.isFeatured = this.cmbFeatured.value.value;
                this.optionName = "Adding...";
                this.AddC();
              } else {
                //Edit
                this.optionName = "Saving...";
                this.myObj.categoryID = this.cmbCat.value.value;
                this.myObj.isFeatured = this.cmbFeatured.value.value;
                this.UpdateC();
              }
            }
          }
        }
      }
    },
    AddC() {
      var url = this.$store.state.domain + "/services";
      axios
        .post(url, this.myObj)
        .then((response) => {
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.LoadData();
            // this.myObj.serviceID = response.data.insertId;
            this.tableData.push(JSON.parse(JSON.stringify(this.myObj)));

            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> New service is added.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        })
        .finally(() => {
          this.saving = false;
          this.nameError = "";
          this.costError = "";
          this.timeError = "";
          this.sequenceError = "";
          this.contactError = "";

          this.myObj.serviceID = 0;
          this.myObj.name = "";
          this.myObj.categoryID = null;
          this.myObj.cost = null;
          this.myObj.time = null;
          this.myObj.sequence = null;
          this.myObj.contact = null;
        });

      console.log(fn);
      this.optionName = "Add";
      this.modals.showModal = false;
    },
    UpdateC() {
      console.log("updating service:", this.myObj.serviceID);
      var url = this.$store.state.domain + "/services/" + this.myObj.serviceID;
      axios
        .put(url, this.myObj)
        .then((response) => {
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.LoadData();
            // Vue.set(this.tableData, this.eIndex, this.myObj);
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> Service Updated.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        });

      console.log(fn);
      this.optionName = "Add";
      this.modals.showModal = false;
    },

    GetError() {
      return this.nameError;
      return this.sequenceError;
      return this.prefixError;
    },
    AddModal() {
      this.saving = false;
      this.categoryData = [];
      // reset the error messages
      this.nameError = false;
      this.timeError = false;
      this.costError = false;

      this.myObj.serviceID = 0;
      this.myObj.categoryID = null;
      this.myObj.name = "";
      this.myObj.cost = null;
      this.myObj.time = null;
      this.myObj.sequence = null;
      this.myObj.contact = null;

      this.shouldAdd = true;
      this.optionName = "Add";
      this.modals.showModal = true;
      this.sign = "fas fa-user-plus";
    },
    editRecord(index, row) {
      this.eIndex = index;
      this.saving = false;
      this.myObj.serviceID = row.serviceID;
      this.myObj.name = row.name;
      this.myObj.categoryID = row.categoryID;
      this.myObj.cost = row.cost;
      this.myObj.time = row.time;
      this.myObj.sequence = row.sequence;
      this.myObj.contact = row.contact;
      this.myObj.isFeatured = row.isFeatured;

      //Populate dropdowns
      this.cmbCat.data.forEach((elem) => {
        if (elem.value === row.categoryID) {
          this.cmbCat.value = elem;
        }
      });

      if (row.isFeatured) {
        this.cmbFeatured.value = {
          name: "Yes",
          value: 1,
        };
      } else {
        this.cmbFeatured.value = {
          name: "No",
          value: 0,
        };
      }

      this.shouldAdd = false;
      this.optionName = "Edit";
      this.modals.showModal = true;
      this.sign = "far fa-edit";
    },
    handleDelete(index, row) {
      var serID = row.serviceID;
      console.log("serID ID", serID);
      swal({
        title: "Are you sure?",
        text: "You want to delete service " + row.name + "?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          //Remove API
          var url = this.$store.state.domain + "/services/" + serID;
          console.log("Remove: " + url);
          axios
            .delete(url)
            .then((response) => {
              console.log(response);
              if (response.data.status === "error") {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: "Request Error! <br />" + response.data.data,
                  type: "danger",
                  icon: "fa fa-ban",
                  timeout: 0,
                });
              } else {
                this.$notify({
                  verticalAlign: "bottom",
                  horizontalAlign: "center",
                  message: 'Done! <br />Service "' + row.name + '" removed.',
                  type: "danger",
                  icon: "fa fa-check",
                  timeout: this.$store.state.timeout,
                });

                this.deleteRow(row);
              }
            })
            .catch(function (error) {
              this.$notify({
                verticalAlign: "bottom",
                horizontalAlign: "center",
                message: "Request Error! <br />" + response.data.data,
                type: "danger",
                icon: "fa fa-ban",
                timeout: 0,
              });
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.serviceID === row.serviceID
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
  computed: {
    getData() {
      return this.$store.state.gridData;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
